import React, {useState,useEffect} from 'react'
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';

import Dropdown from '../../components/Dropdown/Dropdown';

import { Auth, deleteAuth } from '../../../util/Auth';

import { modelProfilePath, getPublicModels } from '../../../services/modelService';
import { getModelPhoto } from '../../../util/ModelPhotos';
import { tempGirls } from '../../../demo/demo';

const Header = ({
    authenticated = null,
    whitebar = false
}) => {

    const navigate = useNavigate()

    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        if (authenticated !== null) return authenticated;
        return !!Auth();
    });

    useEffect(() => {
        if (authenticated !== null) {
            setIsAuthenticated(authenticated);
        }
    }, [authenticated]);

    const [romeHover,setRomeHover] = useState(false)
    const [milanHover,setMilanHover] = useState(false)
    const [headerWhite,setHeaderWhite] = useState(false)
    const [headerWhiteOverride,setHeaderWhiteOverride] = useState(whitebar)

    const [romeGirl,setRomeGirl] = useState(() => getModelPhoto(tempGirls['rome']['talent'][0]))
    const [milanGirl,setMilanGirl] = useState(() => getModelPhoto(tempGirls['milan']['talent'][0]))
    const [romeTalent, setRomeTalent] = useState(tempGirls['rome']['talent'])
    const [milanTalent, setMilanTalent] = useState(tempGirls['milan']['talent'])

    useEffect(() => {
        let mounted = true;
        Promise.all([getPublicModels('rome'), getPublicModels('milan')]).then(([romeModels, milanModels]) => {
            if (!mounted) return;
            setRomeTalent(romeModels);
            if (romeModels.length > 0) {
                setRomeGirl(getModelPhoto(romeModels[0]));
            }
            setMilanTalent(milanModels);
            if (milanModels.length > 0) {
                setMilanGirl(getModelPhoto(milanModels[0]));
            }
        }).catch(() => {
            // Keep the demo catalogue as a navigation fallback when the public API is unavailable.
        });
        return () => { mounted = false; };
    }, []);

    const [menuStatus,setMenuStatus] = useState(false)
    const [accountDropdown,setAccountDropdown] = useState(false)

    const handleRomeHover = () => {
        setHeaderWhite(true)
        handleMilanOverOut()
        setRomeHover(true)
    }
    const handleMilanHover = () => {
        setHeaderWhite(true)
        handleRomeOverOut()
        setMilanHover(true)
    }
    const handleMenuOver = () => {
        setHeaderWhite(false)
        handleRomeOverOut()
        handleMilanOverOut()
    }
    const handleRomeOverOut = () => {
        setRomeHover(false)
    }
    const handleMilanOverOut = () => {
        setMilanHover(false)
    }
    const handleAllOut = () => {
        setMilanHover(false)
        setRomeHover(false)
    }
    const handleHeaderOut = () => {
        setHeaderWhite(false)
    }

    const changeFeaturedGirl = (i,city='rome') => {
        const talent = city === 'rome' ? romeTalent : milanTalent;
        const image = getModelPhoto(talent[i]);
        if (city === 'rome') setRomeGirl(image);
        else setMilanGirl(image);
    }

    const handleMenuStatus = () => {
        if(menuStatus){
            setMenuStatus(false)
            if(!whitebar){
                setHeaderWhiteOverride(false)
            }
            return
        }
        setMenuStatus(true)
        setHeaderWhiteOverride(true)
    }

    useEffect(() => {
        if(whitebar){
            setHeaderWhiteOverride(true)
        }
    }, [whitebar])

    useEffect(() => {
        if(!whitebar){
            const handleScroll = () => {
                const scrollPosition = window.scrollY;
                if(scrollPosition > 100){
                    setHeaderWhiteOverride(true)
                }else {
                    if(!menuStatus)
                    {
                        setHeaderWhiteOverride(false)
                    }
                }
            };
            window.addEventListener('scroll', handleScroll);
            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        }
    }, [whitebar,menuStatus]);

    return (
        <>
        <header className={headerWhite || headerWhiteOverride ? 'white' : ''} onPointerOut={handleHeaderOut}>
            <div className="view-container">
                <div className="menu">
                    <div className={ menuStatus ? "menu-bars open" : "menu-bars"} onPointerOver={handleMenuOver} onClick={handleMenuStatus}>
                        <span>
                            <div></div>
                            <div></div>
                        </span>
                    </div><div className="menu-locations">
                        <ul>
                            <li onPointerOver={handleRomeHover} onClick={handleAllOut}>
                                <Link to={'/talent/rome'}>Rome</Link>
                            </li>
                            <li onPointerOver={handleMilanHover} onClick={handleAllOut}>
                                <Link to={'/talent/milan'}>Milan</Link>
                            </li>
                        </ul>
                    </div>
                </div><div className="logo" onPointerOver={handleMenuOver}>
                    <Link to={'/'}>SADIDA</Link>
                </div><div className={whitebar ? "account black" : "account"} onPointerOver={handleMenuOver}>
                    <ul>
                        <li>
                            <Link to={'/casting'}>Casting</Link>
                        </li>
                        <li className="divide"></li>
                        <li className={accountDropdown ? 'account-nav-item active' : 'account-nav-item'}>
                            <span className="account-link" onClick={(e) => { e.preventDefault(); setAccountDropdown(!accountDropdown); }}>
                            {
                                !isAuthenticated ? <Link to={'/account'}>Login</Link> : 'Account'
                            }
                            </span>
                            {isAuthenticated && accountDropdown && (
                                <div className="account-dropdown">
                                    <Link to={'/account'} onClick={() => setAccountDropdown(false)}>Dashboard</Link>
                                    <Link to={'/account/balance'} onClick={() => setAccountDropdown(false)}>Finances</Link>
                                    <Link to={'/account/ad'} onClick={() => setAccountDropdown(false)}>Advertisement</Link>
                                    <Link to={'/account/store'} onClick={() => setAccountDropdown(false)}>Store</Link>
                                    <span className="dropdown-logout" onClick={() => { deleteAuth(); setIsAuthenticated(false); setAccountDropdown(false); navigate('/'); }}>Logout</span>
                                </div>
                            )}
                        </li>
                    </ul>
                </div>
            </div>
            {
                romeHover ?
                    <div className="location-items" onPointerOver={handleRomeHover} onPointerOut={handleRomeOverOut}>
                        <div className="view-container">
                            {romeTalent.length > 0 && (
                                <div className="li-left">
                                    <div className="li-girl"
                                        style={{backgroundImage: `url(${romeGirl})`}}
                                    ></div>
                                </div>
                            )}<div className="li-right">
                                {romeTalent.length > 0 ? (
                                    <ul>
                                    {
                                        romeTalent.map((girl,index) => {
                                            return <li key={index} onPointerOver={() => changeFeaturedGirl(index,'rome')} onClick={handleAllOut}>
                                                        <Link to={modelProfilePath('rome', girl)}> {girl['name']}</Link>
                                                    </li>
                                        })
                                    }
                                    </ul>
                                ) : (
                                    <div className="city-coming-soon">Models coming soon to Rome</div>
                                )}
                            </div><div className="li-desc">
                                <div className="location-name">{tempGirls['rome']['title']}</div>
                                <div className="location-desc">
                                    <p>{tempGirls['rome']['desc']}</p>
                                </div>
                                <div className="fantasy-link-item" onClick={handleAllOut}><Link to={'/fantasy'}>Custom Fantasy</Link></div>
                            </div>
                        </div>
                    </div>    
                : ''
            }
            {
                milanHover ?
                    <div className="location-items" onPointerOver={handleMilanHover} onPointerOut={handleMilanOverOut}>
                        <div className="view-container">
                            {milanTalent.length > 0 && (
                                <div className="li-left">
                                    <div className="li-girl"
                                        style={{backgroundImage: `url(${milanGirl})`}}
                                    ></div>
                                </div>
                            )}<div className="li-right">
                                {milanTalent.length > 0 ? (
                                    <ul>
                                    {
                                        milanTalent.map((girl,index) => {
                                            return <li key={index} onPointerOver={() => changeFeaturedGirl(index,'milan')} onClick={handleAllOut}>
                                                        <Link to={modelProfilePath('milan', girl)}> {girl['name']}</Link>
                                                    </li>
                                        })
                                    }
                                    </ul>
                                ) : (
                                    <div className="city-coming-soon">Models coming soon to Milan</div>
                                )}
                            </div><div className="li-desc">
                                <div className="location-name">{tempGirls['milan']['title']}</div>
                                <div className="location-desc">
                                    <p>{tempGirls['milan']['desc']}</p>
                                </div>
                                <div className="fantasy-link-item" onClick={handleAllOut}><Link to={'/fantasy'}>Custom Fantasy</Link></div>
                            </div>
                        </div>
                    </div>
            
                : ''
            }
        </header>
        {
            menuStatus ? 
                <>
                    <div className="menu-fader">
                        <div className="menu-tab scrollable">
                            <Dropdown 
                                title={'Home'}
                                linkOnly={true}
                                linkHref={'/'}  
                            />
                            <Dropdown 
                                title={'Talent'} 
                                defaultStatus={true} 
                                pad={true}
                                content={
                                    <>
                                        <div className="dropdown-menu">
                                            <p>
                                                Our agency represents the best talent in the industry, offering a diverse roster of top-tier 
                                                performers who consistently deliver exceptional results.
                                            </p>
                                            <div className="mobile-city-talent">
                                                <Dropdown
                                                    title={'Rome'}
                                                    titleLink={true}
                                                    linkHref={'/talent/rome'}
                                                    content={
                                                        <ul>
                                                        {
                                                            romeTalent.length > 0 ? romeTalent.map((girl) => {
                                                                return <Dropdown
                                                                    key={girl.slug || girl.name}
                                                                    title={girl['name']}
                                                                    linkOnly={true}
                                                                    linkHref={modelProfilePath('rome', girl)}
                                                                />
                                                            }) : <li className="city-coming-soon">Models coming soon to Rome</li>
                                                        }
                                                        </ul>
                                                    }
                                                />
                                                <Dropdown
                                                    title={'Milan'}
                                                    titleLink={true}
                                                    linkHref={'/talent/milan'}
                                                    content={
                                                        <ul>
                                                        {
                                                            milanTalent.length > 0 ? milanTalent.map((girl) => {
                                                                return <Dropdown
                                                                    key={girl.slug || girl.name}
                                                                    title={girl['name']}
                                                                    linkOnly={true}
                                                                    linkHref={modelProfilePath('milan', girl)}
                                                                />
                                                            }) : <li className="city-coming-soon">Models coming soon to Milan</li>
                                                        }
                                                        </ul>
                                                    }
                                                />
                                            </div>
                                            <div className="mobile-talent-btns">
                                                <div className="view-all-btn">
                                                    <Link to={'/talent'}>View All</Link>
                                                </div>
                                                <div className="view-all-btn fantasy-btn">
                                                    <Link to={'/fantasy'}>Custom Fantasy</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            />
                            <div className="menu-spacer"></div>
                            <Dropdown
                                title={'Casting'}
                                linkOnly={true}
                                linkHref={'/casting'}
                            />
                            {isAuthenticated ? (
                                <>
                                    <Dropdown
                                        title={'Account'}
                                        content={
                                            <ul onClick={handleMenuStatus}>
                                                <Dropdown title={'Dashboard'} linkOnly={true} linkHref={'/account'} />
                                                <Dropdown title={'Finances'} linkOnly={true} linkHref={'/account/balance'} />
                                                <Dropdown title={'Advertisement'} linkOnly={true} linkHref={'/account/ad'} />
                                                <Dropdown title={'Store'} linkOnly={true} linkHref={'/account/store'} />
                                                <div className="mobile-logout" onClick={() => { deleteAuth(); setIsAuthenticated(false); handleMenuStatus(); navigate('/'); }}>
                                                    Logout
                                                </div>
                                            </ul>
                                        }
                                    />
                                </>
                            ) : (
                                <Dropdown
                                    title={'Login'}
                                    linkOnly={true}
                                    linkHref={'/account'}
                                />
                            )}
                            <Dropdown
                                title={'Contact'}
                                linkOnly={true}
                                linkHref={'/contact'}
                            />
                        </div>
                    </div>
                </> : ''
        }

        </>
    )

}

export default Header;